import { render } from "./CommunityPharmacyInformation.vue?vue&type=template&id=77464aa7"
import script from "./CommunityPharmacyInformation.vue?vue&type=script&lang=js"
export * from "./CommunityPharmacyInformation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__